import { TextField, styled } from '@mui/material';

interface IStyledTextFieldProps {
  width?: string;
}

const SearchInput = styled(TextField)<IStyledTextFieldProps>(({ theme }) => ({
  width: '100%',
  height: '36px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '5px',
    backgroundColor: theme.palette.primary.light,
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      border: 'none',
    },
    '&.Mui-focused fieldset': {
      border: 'none',
    },
  },
  '& .MuiInputBase-input': {
    ...theme.typography.bodyRegular,
    '&:-webkit-autofill': {
      '-webkit-text-fill-color': theme.palette.primary.dark,
      '-webkit-box-shadow': `0 0 0 1000px ${theme.palette.primary.light} inset`,
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: '12px 8px',
    fontSize: '16px',
    lineHeight: '20px',
    color: theme.palette.primary.main,
    fontFamily: 'Satoshi',
  },
}));

export default SearchInput;
